<template>
    <div style="padding: 2rem 3rem; text-align: left;">
        <div class="field"  v-if="model && model.plans && model.plans.features">
            <div class="col-md" style="background-color: #F2F2F2;;margin: 20px 10px 0px 10px; padding: 15px; font-size: 20px">
                <h3>Service Plan Info</h3>
                <hr/>
                <div class="row" v-if="!model.installation.valve_control_enabled">
                    <div class="col-4">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Basic</span>
                        <div style="padding: 20px">
                            <ul style="font-weight: bold; font-size:12px">
                                <li>1 User</li>
                                <li>Up to 2 Active Alerts</li>
                                <!--<li>Annual WaterMetrix™ Reports</li>-->
                                <li>App and Dashboard access</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col text-right"><b-form-checkbox size="lg" v-model="selectedPlan" value="5"/></div>
                    <div class="col-3">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Yearly - $107.99<br/>($8.99 / Month)</span>
                    </div>
                    <div class="col text-right"><b-form-checkbox size="lg" v-model="selectedPlan" value="1"/></div>
                    <div class="col-3">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Pay As You Go<br/>$9.99 / Month</span>
                    </div>
                </div>
              <hr v-if="!model.installation.valve_control_enabled"/>

                <div class="row">
                    <div class="col-4">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Premium</span>
                        <ul style="font-weight: bold; font-size:12px">
                            <li>Up to 2 Users</li>
                            <li>Up to 6 Active Alerts</li>
                            <li>Flow Rate Information</li>
                            <li>Remote Valve Control*</li>
                            <li>WaterMetrix™ Remote Audits</li>
                            <li>Unlimited App and Dashboard Access</li>
                        </ul>
                    </div>
                    <div class="col text-right"><b-form-checkbox size="lg" v-model="selectedPlan" value="6"/></div>
                    <div class="col-3">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Yearly - $159.99<br/>($14.99 / Month)</span>
                    </div>
                    <div class="col text-right"><b-form-checkbox size="lg" v-model="selectedPlan" value="3"/></div>
                    <div class="col-3">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Pay As You Go<br/>$14.99 / Month</span>
                    </div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Enterprise</span>
                        <ul style="font-weight: bold; font-size:12px">
                            <li>Up to 10 Users</li>
                            <li>Unlimited Active Alerts</li>
                            <li>Flow Rate Information</li>
                            <li>Remote Valve Controls*</li>
                            <li>3 Free WaterMetrix™ Audits</li>
                            <li>Unlimited App and Dashboard Access</li>
                        </ul>
                    </div>
                    <div class="col text-right"><b-form-checkbox size="lg" v-model="selectedPlan" value="7"/></div>
                    <div class="col-3">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Yearly - $479.99<br/>($39.99 / Month)</span>
                    </div>
                    <div class="col text-right"><b-form-checkbox size="lg" v-model="selectedPlan" value="4"/></div>
                    <div class="col-3">
                        <span style="color: #296a9b; font-weight: bold; font-size: 24px">Pay As You Go<br/>$44.99 / Month</span>
                    </div>
                </div>
            </div>
            <b-form-group style="padding: 20px" ref="card">
                <h4>Enter Billing CC Info</h4>
                <card 
                    class='stripe-card'
                    :stripe='stripe_pk'
                    :options='stripeOptions'
                    :class='{ complete }'
                    @change='complete=$event.complete'
                />
            </b-form-group>
        </div>
    </div>
</template>

<script>

    import { Card } from 'vue-stripe-elements-plus'


    export default {
        props: {
            model:{ type: Object }
        },

        components: { Card },
        data(){
            return{
                stripe_pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
                complete: false,
                selectedPlan: null,
                basic_yearly: false,
                basic_monthly: false,
                premium_yearly: false,
                premium_monthly: false,
                enterprise_yearly: false,
                enterprise_monthly: false,
                stripeOptions: {
                    style: {
                        base: {
                            color: '#303238',
                            fontSize: '16px',
                            color: "#32325d",
                            fontSmoothing: 'antialiased',
                            '::placeholder': { color: '#ccc' }
                        }
                    }
                }
            }
        },
        mounted() {
            this.$emit('can-continue', {value: true})
        },
        watch: {
            selectedPlan() {
                console.log("updated")
                this.$emit('emit-model', {selectedPlan: this.selectedPlan})
            }
        }
    }

</script>

<style scoped>

    .stripe-card {
        width: 100%;
        background-color: #eeeeee !important;
        text-color: black !important;
        font-weight: bold;
        border-radius: 0.25rem;
        border: 1px solid #1A75BB;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 10px;
    }

    .pricing-card { background: white }
    .pricing-card .card-body{ 
        text-align: center;
        padding: 0px 
    }

    .pricing-title {
        background: #f5f5f5;
        border-bottom: 3px solid #eee;
        height: 78px;

        color: #444;
        font-size: 1.6rem;
        font-weight: bold;
        margin-bottom: 0rem!important;

        padding: 1.4rem .2rem;
        position: relative;
        text-align: center;
    }

    .pricing-text {
        color: #57626f;
        padding: 1rem;
        font-size: 1.2rem;
        text-align: center;
        background: white;
        margin-bottom: 0rem
    }

    .pricing-price{
        font-size: 2rem;
        color: #EF7215;        
    }

    .pricing-button{ color:#212529!important }
    .pricing-button:hover { color: white!important }
    .pricing-button-selected{ 
        color: white!important;
        background: #3383c8;
        border-color: #3383c8;
    }

    .pricing-button-selected:hover { color: white!important }
    .pricing-card .card-footer{
        background: white; 
        height: 83px;
        text-align: center;
        padding-top: 22px
    }

    .true::before {
        content: "✓"; 
        font-size: 24px; 
        color: #3383c8;
    }

    .true{padding:6px!important}

</style>
